import UploadFileTile from 'components/UploadFile/UploadFileTile';
import { Grid } from 'styles';
import { IFileType } from 'types/Claim';
import { STATE_KEYS } from 'types/Store';
import { DocType } from 'types/Upload';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import DocumentCard from './UploadGridCard';

type DocumentGridProps = {
	clearDocumentsKey: STATE_KEYS;
	documentType: DocType;
	data: IFileType[];
};

const UploadGrid = ({
	documentType,
	data,
	clearDocumentsKey,
}: DocumentGridProps) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	return (
		<Grid container columnSpacing={2} rowSpacing={2}>
			{data.map(attachment => (
				<Grid key={attachment.uuid} item sm={3}>
					<DocumentCard
						key={attachment.uuid}
						uuid={attachment.uuid}
						fileName={attachment.fileName}
						documentType={documentType}
						clearDocumentsKey={clearDocumentsKey}
					/>
				</Grid>
			))}
			<Grid item sm={3}>
				<UploadFileTile
					label={tClientLabels(`${documentType}.upload.docNames.1`)}
					labelUpload={tClientLabels(`${documentType}.upload.docNames.1`)}
					documentType={documentType}
					showIcon={false}
				/>
			</Grid>
		</Grid>
	);
};

export default UploadGrid;
